module.exports = __webpack_public_path__ + "static/img/2.c0f1e277.png";